import { render, staticRenderFns } from "./ParteDetalleView.vue?vue&type=template&id=afff224c&scoped=true&"
import script from "./ParteDetalleView.vue?vue&type=script&lang=js&"
export * from "./ParteDetalleView.vue?vue&type=script&lang=js&"
import style0 from "./ParteDetalleView.vue?vue&type=style&index=0&id=afff224c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afff224c",
  null
  
)

export default component.exports